export default "__VITE_ASSET__C$cgk3r1__"